import { useCountdownTimer } from 'react-easyrocket';
import { useGetEvent } from 'src/config/hooks/useGetEvent';

export const useTimerDaysEvent = () => {
  const event = useGetEvent();
  const timeLeft = useCountdownTimer(event?.dateEnd);

  const daysLeft = timeLeft.days;
  const hoursLeft = timeLeft.hours;
  const minutesLeft = timeLeft.minutes;
  const secondsLeft = timeLeft.seconds;

  return { daysLeft, minutesLeft, hoursLeft, secondsLeft };
};
